import { S as Swiper } from './swiper-core-BtjM6e_D.js';
import { N as Navigation } from './navigation-BQb6BNJ8.js';
import { A as A11y } from './a11y-BYUO09Sv.js';
import './create-element-if-not-defined-DGsapWum.js';

class FeaturedCollection extends HTMLElement {
  swiper = this.querySelector('.swiper');
  nextButton = this.querySelector('.swiper-button-next');
  prevButton = this.querySelector('.swiper-button-prev');

  connectedCallback() {
    this.swiperInstance = new Swiper(this.swiper, {
      modules: [A11y, Navigation],
      slidesPerView: 1.4,
      spaceBetween: 1,
      lazyPreloadPrevNext: 2,
      loop: true,
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },
      breakpoints: {
        768: {
          slidesPerView: 3.2,
        },
        1024: {
          slidesPerView: 3.6,
        },
      },
    });
  }
}

customElements.define('featured-collection', FeaturedCollection);
